if (!customElements.get('stat-count')) {
  class StatCount extends HTMLElement {
    connectedCallback() {
      // Defer one tick so the parser has time to add child text nodes before
      // we read textContent (relevant when the element is upgraded synchronously)
      setTimeout(() => this._init());
    }

    _init() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.Shopify && Shopify.designMode) return;

      const raw = this.textContent.trim();
      // Extract optional prefix, numeric value, optional suffix
      const match = raw.match(/^([^\d]*)(\d[\d,.]*)(.*)$/);
      if (!match) return;

      const [, prefix, numStr, suffix] = match;
      const target = parseFloat(numStr.replace(/,/g, ''));
      if (isNaN(target) || target === 0) return;

      this._prefix = prefix;
      this._suffix = suffix;
      this._target = target;
      this._decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;

      // Show 0 immediately before intersection fires
      this.textContent = prefix + '0' + suffix;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(this);
            // Delay matches the slide-in animation duration (600ms) so card fully
            // fades in before the count starts
            setTimeout(() => this._run(), 600);
          }
        });
      }, { rootMargin: '0px 0px -50px 0px' });

      observer.observe(this);
    }

    _run() {
      const duration = 1800;
      const start = performance.now();
      const target = this._target;
      const decimals = this._decimals;

      const tick = (now) => {
        const elapsed = now - start;
        const t = Math.min(elapsed / duration, 1);
        // ease-out cubic
        const eased = 1 - Math.pow(1 - t, 3);
        const value = eased * target;
        this.textContent = this._prefix + value.toFixed(decimals) + this._suffix;
        if (t < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    }
  }

  customElements.define('stat-count', StatCount);
}
